import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const Logo: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 100 100">
      <path
        fill="currentColor"
        d="M30 20 L30 80 L80 50 L30 20"
        opacity="0.8"
      />
      <path
        fill="currentColor"
        d="M15 30 L15 70 L55 50 L15 30"
        opacity="0.6"
      />
    </SvgIcon>
  );
};

export default Logo;
